import { RequestNames } from "../backend/requests";

export interface Entity {
    listRequest: RequestNames;
    getRequest: RequestNames;
    selectRequest: RequestNames;
    filteredRequest: boolean;
    linkedRequests?: Array<RequestNames>;
}

export interface RecordMessage {
    key: string;
}

export interface RecordCreatedMessage {
    key: string;
    record: any;
}

export interface RecordUpdatedMessage {
    key: string;
    id: string;
    record: any;
}

export interface RecordDeletedMessage {
    key: string;
    id: string;
}

// TODO add entities
export enum Entities {
    UserManagement = "users/management",
    UserSetting = "users/setting",
    UserProfile = "users/profile",
    FleetProfile = "users/fleetprofile",
    Registration = "registration",
    Appointments = "appointments",
    Calendar = "calendar",
    FacilityTypes = "facilitytypes",
    Facilities = "facilities",
    Service = "settings/service",
    ServiceSetting = "settings/servicesettings",
    FleetSetting = "settings/fleetsettings",
    Account = "settings/account",
    RepairedMakes = "settings/repairedmakes",
    ServicePartners = "settings/servicepartners",
    Reviews = "reviews",
    AppointmentWorksheets = "appointmentworksheets",
    Worksheets = "worksheets",
    FinishedWorksheets = "finishedworksheets",
    PendingWorksheets = "pendingworksheets",
    Customers = "customers",
    ServiceCars = "servicecars",
    Cars = "cars",
    FleetCustomers = "fleetcustomers",
    Promotions = "promotions",
    Warehouse = "settings/warehouse",
    Parts = "parts",
    PartTypes = "parttypes",
    PartGroups = "partgroups",
    PartUnits = "partunits",
    Suppliers = "suppliers",
    Discounts = "discounts",
    InventoryEvents = "inventoryevents",
    Vats = "vats",
    Inventories = "Inventories",
}
